import React from 'react'

/**
 * USOKIE Platform Check Email Page
 * Clean confirmation with generous spacing
 */
const CheckEmailPage = ({ email, onBack }) => {
  return (
    <div className="w-full">
      {/* Mobile logo - only visible on small screens */}
      <div className="lg:hidden mb-16">
        <img
          src="/images/usokie-logo-bone.png"
          alt="USOKIE"
          className="w-40 h-auto"
        />
      </div>

      {/* Header */}
      <div className="mb-16">
        <div className="flex items-center gap-4 mb-8">
          <span
            className="text-xs text-[#a1c6a2] tracking-[0.3em] uppercase"
            style={{ fontFamily: "'GT Pressura Mono', monospace" }}
          >
            Link Sent
          </span>
          <div className="flex-1 h-px bg-[rgba(255,251,247,0.1)]" />
        </div>

        <h1 className="text-4xl lg:text-5xl font-bold text-[#fffbf7] tracking-tight mb-6">
          Check Your Email
        </h1>
        <p className="text-lg text-[rgba(255,251,247,0.5)] leading-relaxed">
          We've sent a secure login link to:
        </p>
      </div>

      {/* Email Display */}
      <div className="mb-16 py-6 border-l-2 border-[#a1c6a2] pl-8">
        <span
          className="text-xl text-[#fffbf7]"
          style={{ fontFamily: "'GT Pressura Mono', monospace" }}
        >
          {email}
        </span>
      </div>

      {/* Instructions */}
      <div className="mb-16">
        <div className="flex items-center gap-4 mb-8">
          <span
            className="text-xs text-[rgba(255,251,247,0.4)] tracking-[0.2em] uppercase"
            style={{ fontFamily: "'GT Pressura Mono', monospace" }}
          >
            Next Steps
          </span>
          <div className="flex-1 h-px bg-[rgba(255,251,247,0.08)]" />
        </div>

        <div className="space-y-6">
          <div className="flex items-start gap-6">
            <span
              className="w-8 h-8 border border-[#a1c6a2] text-[#a1c6a2] text-sm flex items-center justify-center flex-shrink-0"
              style={{ fontFamily: "'GT Pressura Mono', monospace" }}
            >
              1
            </span>
            <span className="text-lg text-[rgba(255,251,247,0.6)] pt-1">
              Open your email inbox
            </span>
          </div>
          <div className="flex items-start gap-6">
            <span
              className="w-8 h-8 border border-[#a1c6a2] text-[#a1c6a2] text-sm flex items-center justify-center flex-shrink-0"
              style={{ fontFamily: "'GT Pressura Mono', monospace" }}
            >
              2
            </span>
            <span className="text-lg text-[rgba(255,251,247,0.6)] pt-1">
              Find the email from USOKIE
            </span>
          </div>
          <div className="flex items-start gap-6">
            <span
              className="w-8 h-8 border border-[#a1c6a2] text-[#a1c6a2] text-sm flex items-center justify-center flex-shrink-0"
              style={{ fontFamily: "'GT Pressura Mono', monospace" }}
            >
              3
            </span>
            <span className="text-lg text-[rgba(255,251,247,0.6)] pt-1">
              Click the login link to continue
            </span>
          </div>
        </div>
      </div>

      {/* Notice */}
      <div className="mb-16 py-5 border-l-2 border-[rgba(255,251,247,0.1)] pl-6">
        <p className="text-base text-[rgba(255,251,247,0.4)] leading-relaxed">
          Didn't receive the email? Check your spam folder or verify the address is correct.
        </p>
      </div>

      {/* Footer info */}
      <div className="flex items-center gap-6 mb-16">
        <span
          className="text-xs text-[rgba(255,251,247,0.3)] tracking-wider"
          style={{ fontFamily: "'GT Pressura Mono', monospace" }}
        >
          Link expires in 15 minutes
        </span>
        <div className="w-1 h-1 bg-[rgba(255,251,247,0.2)] rounded-full" />
        <span
          className="text-xs text-[rgba(255,251,247,0.3)] tracking-wider"
          style={{ fontFamily: "'GT Pressura Mono', monospace" }}
        >
          One-time use
        </span>
      </div>

      {/* Back Button */}
      {onBack && (
        <button
          onClick={onBack}
          className="text-base text-[rgba(255,251,247,0.5)] hover:text-[#a1c6a2] transition-colors"
          style={{ fontFamily: "'GT Pressura Mono', monospace" }}
        >
          ← Back to Login
        </button>
      )}
    </div>
  )
}

export default CheckEmailPage
